import './App.css';
import { Avatar, Button, Container, List, ListItem } from '@material-ui/core';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';

const instagramUrl = "https://www.instagram.com/moniichen13/";
const facebookUrl = "https://www.facebook.com/moniichen13/";
const popDailyUrl = "https://www.popdaily.com.tw/user/280191";

function App() {
  return (
    <Container maxWidth="md">
      <div className="App">
        <header className="App-header">
          {renderCover()}
          {renderLinks()}
          {renderIntroduction()}
          {renderCategories()}
          {renderArticles()}
        </header>
      </div>
    </Container>
  );
}

function renderCover() {
  return (
    <div className="cover">
      <Avatar style={{width: 150, height: 150}} alt="Monii" src="/logo.jpg"/>
      <img style={{width: 150}} alt="Monii" src="/monii.png"/>
    </div>
  )
}

function renderIntroduction() {
  return (
    <div className="intro">
      <div style={{fontWeight: 'bold'}}>陳莫妮｜居家𝕩美食𝕩穿搭𝕩景點</div>
      <div>。🅔🅝🅙🅞🅨 𝕝𝕚𝕗𝕖。生活藝術家</div>
      <div>拍照📷-穿搭👒-吃貨🍔- 小倆口👫 </div>
      <div>👉🏻台北螞蟻｜北漂高雄人｜偽台中人</div>
      <div>👉🏻全台亂玩｜景點美拍｜生活體驗</div>
    </div>
  )
}

function renderLinks() {
  return (
    <div className="links">
      <Button target="_blank" href={instagramUrl} color="primary">
        <InstagramIcon alt="instagram" style={{ fontSize: 50, color: '#815951' }}/>
      </Button>          
      <Button target="_blank" href={facebookUrl} color="primary">
        <FacebookIcon alt="facebook" style={{ fontSize: 50, color: '#815951' }}/>
      </Button>
      <Button target="_blank" href={popDailyUrl} color="primary">
        <img alt="popdaily" src="/popdaily-2.png" style={{ width: 40, borderRadius: 5 }}/>
      </Button>
    </div>
  )
}

function renderCategoriesV2() {
  return (
    <div className="cate">
      <List component="nav" aria-label="categories">
        <ListItem button component="a" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E4%B8%8D%E5%9C%A8%E5%AE%B6/">#莫妮不在家 ᴛʀᴀᴠᴇʟ 遊玩</ListItem>
        <ListItem button component="a" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E6%84%9B%E6%BC%82%E6%BC%82/">#莫妮愛漂漂 ᴏᴏᴛᴅ 穿搭</ListItem>
        <ListItem button component="a" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E6%98%AF%E5%B0%8F%E8%B1%AC/">#莫妮是小豬 ғᴏᴏᴅ 食記</ListItem>
        <ListItem button component="a" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E6%84%9B%E4%BD%88%E7%BD%AE/">#莫妮愛佈置 ᴅᴇᴄᴏʀ 居家</ListItem>
      </List>
    </div>
  )
}

function renderCategories() {
  return (
    <div className="cate">
      <Button variant="contained" color="secondary" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E4%B8%8D%E5%9C%A8%E5%AE%B6/">#莫妮不在家 ᴛʀᴀᴠᴇʟ 遊玩</Button>
      <Button variant="contained" color="secondary" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E6%84%9B%E6%BC%82%E6%BC%82/">#莫妮愛漂漂 ᴏᴏᴛᴅ 穿搭</Button>
      <Button variant="contained" color="secondary" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E6%98%AF%E5%B0%8F%E8%B1%AC/">#莫妮是小豬 ғᴏᴏᴅ 食記</Button>
      <Button variant="contained" color="secondary" target="_blank" href="https://www.instagram.com/explore/tags/%E8%8E%AB%E5%A6%AE%E6%84%9B%E4%BD%88%E7%BD%AE/">#莫妮愛佈置 ᴅᴇᴄᴏʀ 居家</Button>
    </div>
  )
}

function renderArticles() {
  return (
    <div className="article">
      <Button variant="contained" color="secondary" target="_blank" href="https://www.popdaily.com.tw/forum/style/1089092">#文章【莫莉小ck聯名-根本穿搭神器】</Button>
      <Button variant="contained" color="secondary" target="_blank" href="https://www.popdaily.com.tw/forum/travel/1062919">#文章【宜蘭-張美阿嬤農場水豚君】</Button>
      <Button variant="contained" color="secondary" target="_blank" href="https://www.popdaily.com.tw/forum/food/1057086">#文章【食譜-巴斯克焦黑乳酪蛋糕】</Button>
      {/* <Button variant="contained" color="secondary" target="_blank" href="https://www.popdaily.com.tw/forum/style/1054115">#文章【OOTD-一週穿搭】</Button> */}
    </div>
  )
}


export default App;
